import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
  fill: "#E9FAD2"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.803 10.125c.198 0 .375.075.531.225a.711.711 0 0 1 .216.522v14.256a.711.711 0 0 1-.216.522.746.746 0 0 1-.53.225H13.796a.746.746 0 0 1-.531-.225.711.711 0 0 1-.216-.522V22.5H9.297a.762.762 0 0 1-.531-.216.762.762 0 0 1-.216-.531v-7.506c0-.198.072-.375.216-.531a.762.762 0 0 1 .531-.216h3.753v-2.628c0-.204.072-.378.216-.522a.746.746 0 0 1 .531-.225h12.006ZM13.05 18.954l1.062 1.998h1.611l-1.773-2.898 1.737-2.853h-1.539l-.981 1.809-.036.054-.027.063a21.308 21.308 0 0 0-.504-.963c-.15-.318-.309-.639-.477-.963h-1.629l1.701 2.871-1.845 2.88h1.602l1.098-1.998Zm6.192 5.796V22.5h-5.067v2.25h5.067Zm0-3.375v-2.808H17.55v2.808h1.692Zm0-3.933v-2.817H17.55v2.817h1.692Zm0-3.942v-2.25h-5.067v2.25h5.067Zm6.183 11.25V22.5h-5.058v2.25h5.058Zm0-3.375v-2.808h-5.058v2.808h5.058Zm0-3.933v-2.817h-5.058v2.817h5.058Zm0-3.942v-2.25h-5.058v2.25h5.058Z",
  fill: "#4CAD20"
});
function ExcelAvatar(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? colors.neutral700 : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _ref2, _ref3);
}
export default ExcelAvatar;